export default function DownloadCTA() {
  return (
    <section id="download" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary-500 via-primary-400 to-accent-400 p-8 md:p-14">
          <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>

          <h2 className="relative font-heading text-2xl md:text-4xl text-white mb-3">
            准备好开始创作了吗？
          </h2>
          <p className="relative text-sm md:text-base text-white/80 mb-8 max-w-lg mx-auto">
            下载香蕉视频App，加入2亿用户的创意社区。发现精彩内容，记录你的每一个高光时刻！
          </p>
          <div className="relative flex items-center justify-center gap-4 flex-col sm:flex-row">
            <a
              href="#"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-white text-primary-600 font-medium text-sm hover:bg-white/90 transition-all duration-300 hover:scale-105 inline-flex items-center gap-2"
            >
              <i className="ri-apple-line text-lg"></i> App Store 下载
            </a>
            <a
              href="#"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-foreground-950 text-white font-medium text-sm hover:bg-foreground-800 transition-all duration-300 hover:scale-105 inline-flex items-center gap-2"
            >
              <i className="ri-android-line text-lg"></i> Android 下载
            </a>
          </div>
          <p className="relative text-xs text-white/50 mt-4">
            完全免费 · 无需注册即可浏览 · 支持 iOS 14+ 和 Android 8+
          </p>
        </div>
      </div>
    </section>
  );
}